module.exports = new __parcel__URL__("marksman.73cc29a3.png").toString();